{
  "title": "Central Catalog",
  "subtitle": "Material master — code, category, UOM, stock policy, storage, and QC configuration.",
  "addMaterial": "Add New Item",
  "search": "Search materials...",
  "allCategories": "All Categories",
  "table": {
    "code": "Code",
    "name": "Material Name",
    "category": "Category",
    "uom": "UOM",
    "reorderLevel": "Reorder Level",
    "status": "Status",
    "client": "Client",
    "customer": "Customer"
  },
  "tabs": {
    "general": "General Info",
    "storage": "Storage & Warehouse",
    "policy": "Inventory Policy"
  },
  "form": {
    "code": "Material Code",
    "name": "Material Name",
    "category": "Category",
    "uom": "UOM",
    "barcode": "Barcode",
    "abcClass": "ABC Category",
    "abcNone": "Unclassified",
    "supplier": "Supplier",
    "client": "Client",
    "customer": "Customer",
    "customerHelperNeedsClient": "Select a Client first — only its mapped Customers are offered here.",
    "storageType": "Storage Type",
    "rackNo": "Rack No",
    "binLocation": "Bin Location",
    "storageConditionRequirement": "Storage Condition Requirement",
    "storageConditionNone": "No special requirement",
    "storageConditionAmbient": "Ambient",
    "storageConditionColdStorage": "Cold Storage",
    "storageConditionHazardous": "Hazardous",
    "storageConditionFragile": "Fragile",
    "storageConditionTemperatureControlled": "Temperature Controlled",
    "defaultLocation": "Assigned Putaway Location",
    "defaultLocationNone": "None — select at putaway time",
    "defaultLocationHelper": "Pre-fills the Putaway screen's location for this item whenever it's shelved.",
    "batchTrackingRequired": "Batch Tracking Required",
    "shelfLifeRequired": "Shelf Life Required",
    "shelfLifeDays": "Shelf Life (Days)",
    "qcRequired": "QC Inspection Required",
    "checkpointValidationRequired": "Checkpoint Validation Required (item-wise)",
    "qcTemplate": "QC Checkpoint Template",
    "qcTemplateDefault": "Use global default",
    "qcTemplateDefaultBadge": "Default",
    "qcTemplateHelper": "Overrides the global default template for this item only. Enable Checkpoint Validation Required above to map one.",
    "minStock": "Minimum Stock",
    "maxStock": "Maximum Stock",
    "reorderLevel": "Reorder Level",
    "safetyStock": "Safety Stock",
    "unitWeight": "Unit Weight",
    "unitVolume": "Unit Volume",
    "stuffingQty": "Stuffing Qty",
    "stuffingQtyHelper": "Quantity per stuffing/container-load unit for this material.",
    "labelTemplate": "Label Template",
    "labelTemplateNone": "None",
    "labelTemplateHelper": "Auto-selected for this item on the GRN Label Print screen.",
    "validation": {
      "codeRequired": "Material code is required.",
      "nameRequired": "Material name is required.",
      "clientRequired": "Client is required — 3PL is enabled for this company.",
      "customerRequired": "Customer is required — 3PL is enabled for this company.",
      "minWeightRequired": "Minimum weight is required.",
      "maxWeightRequired": "Maximum weight is required.",
      "maxWeightBelowMin": "Maximum weight must be greater than or equal to minimum weight.",
      "weightUomRequired": "Weight unit is required.",
      "shelfLifeRequiredForWeightProduction": "Shelf Life must be enabled for a Weigh & Label item — the Kiosk uses it to calculate every label's expiry date.",
      "shelfLifeDaysRequiredForWeightProduction": "Shelf Life Days is required for a Weigh & Label item."
    }
  },
  "discardChanges": "Discard Changes",
  "saveMaterial": "Save Material",
  "deleteMaterial": {
    "message": "This material will be permanently removed from the catalog."
  }
}
